/**
  * 设备管理-->参数设备状态
  * @param unit 单位
  * @param xData x轴数据
  * @param dataArr y轴数据合集
  * @param type 默认样式
*/
export function setOption(paramObj) {
  let option = {
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        let res = params[0].name + "<br />设备状态：";
        let texts = "";
        if (params[0].value === 5 || params[0].value === "5") {
          texts = "离线状态";
        } else if (params[0].value === 15 || params[0].value === "15") {
          texts = "正常运行";
        } else if (params[0].value === 25 || params[0].value === "25") {
          texts = "非正常运行";
        }
        res = res + texts;
        return res;
      },
    },
    legend: {
      top: "1%",
      right: "2%",
      textStyle: {
        color: "#333",
        fontSize: 16,
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },

    xAxis: {
      type: "category",
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        interval: 0,
        color: "#CBCBCB",
        fontSize: 16,
        // margin: 15,
      },
      data: ["1:00", "2:00", "3:00", "4:00", "5:00", "6:00", "7:00"],
    },
    yAxis: {
      type: "value",
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#EBEBEB",
        },
      },
      axisLabel: {
        show: true,
        color: "#999",
        fontSize: 13,
        formatter: function (value) {
          let texts = [];
          if (value === 5 || value === "5") {
            texts.push("离线状态");
          } else if (value === 15 || value === "15") {
            texts.push("正常运行");
          }

          return texts;
        },
      },
    },
    visualMap: {
      show: false,
      pieces: [
        { gt: 1, lte: 10, color: "#999" },
        { gt: 10, lte: 20, color: "#3579FF" },
      ],
    },
    series: [
      {
        name: "设备状态",
        type: "line",
        step: "end",
        itemStyle: {
          lineStyle: {
            width: 5,
          },
        },
        data: [5, 15, 15, 5, 5, 5, 15],
      },
    ],
  }
 

  return option
  
}